import { Controller } from "@hotwired/stimulus"

// Points the preview frame under a Match rule's value picker at the values currently
// selected. The server decides what each value catches (PipelineRules::VocabularyMatchPreview),
// so this only builds the URL; it never repeats the matching.
//
// Connects to data-controller="vocabulary-match-preview"
export default class extends Controller {
  static targets = ["select", "frame"]
  static values = { url: String }

  // The negate checkbox sits in the rule form above this partial, outside the controller's
  // element, so it is found through the form rather than as a target.
  connect() {
    this.negateCheckbox = this.element.closest("form")?.querySelector("input[type=checkbox][name='pipeline_rules_rule[negate_trigger]']")
    this.boundRefresh = this.refresh.bind(this)
    this.negateCheckbox?.addEventListener("change", this.boundRefresh)
    this.refresh()
  }

  disconnect() {
    this.negateCheckbox?.removeEventListener("change", this.boundRefresh)
  }

  // search-select dispatches `change` after every pick, removal, and added value, so this
  // runs once per edit rather than per keystroke in the search box.
  refresh() {
    if (!this.hasSelectTarget || !this.hasFrameTarget || !this.urlValue) return

    const url = new URL(this.urlValue, window.location.origin)
    Array.from(this.selectTarget.selectedOptions).forEach((option) => {
      url.searchParams.append("values[]", option.value)
    })
    if (this.negateCheckbox?.checked) url.searchParams.set("negated", "true")

    this.frameTarget.src = url.toString()
  }
}
